import { useEffect, useRef, useState } from "react";
import { useSnackbar } from "notistack";

import dayjs from "@lib/dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelSubscriptionThunk,
  fetchActiveSubscriptionThunk,
  setActivePlan,
  undoCancelSubscription,
} from "../../store/actions/subscription.action";
import { undoCancelSubcription } from "../../endpoints/subscription.service";
import { useNavigate } from "react-router-dom";
import LoadingAnimation from "../../assets/svg/LoadingAnimation";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";


const MySubscriptionPage = () => {
  const dispatch = useDispatch();
  const activeSubscription = useSelector(
    (state) => state.subscription.activeSubscription
  );
  // const loading = useSelector((state) => state.subscription.loading);
  // const [activeSubscription, setActiveSubscription] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const mySubscriptionRef = useRef(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [isCancelLoading, setIsCancelLoading] = useState(false);

  useEffect(() => {
    if (mySubscriptionRef.current) return;
    mySubscriptionRef.current = true;
    dispatch(fetchActiveSubscriptionThunk()).finally(() => setIsLoading(false));
    console.log("activeSubscription", activeSubscription?.hasCancelRequest);
    // getActiveSubscription();
  }, []);

  const handleUpgradePlan = () => {
    dispatch(
      setActivePlan({
        recurringType: activeSubscription?.planDetails?.recurringType,
      })
    );
    navigate("/subscription/plans", {
      state: {
        recurringType: activeSubscription?.planDetails?.recurringType,
      },
    });
  };

  const handleCancelSubscription = () => {
    if (isCancelLoading) return; // Prevent multiple clicks

    console.log("subscriptionid", activeSubscription._id);
    setIsCancelLoading(true);
    dispatch(cancelSubscriptionThunk(activeSubscription._id))
      .then((response) => {
        console.log("response", response);
        if (response) {
          // Force update the Redux state with the updated subscription
          const updatedSubscription = {
            ...activeSubscription,
            hasCancelRequest: true,
          };

          dispatch({
            type: "FETCH_ACTIVE_SUBSCRIPTION_PLAN_SUCCESS",
            payload: { activeSubscription: updatedSubscription },
          });

          enqueueSnackbar(
            `Your subscription has been cancelled successfully and will ends at  ${dayjs(
              activeSubscription?.endDate
            ).format("MMMM D, YYYY")}`,
            {
              variant: "success",
            }
          );
        }
      })
      .catch((error) =>
        enqueueSnackbar("Error while cancelling subscription", {
          variant: "error",
        })
      )
      .finally(() => setIsCancelLoading(false));
  };

  const handleUndoCancelSubscription = () => {
    if (isCancelLoading) return; // Prevent multiple clicks

    setIsCancelLoading(true);

    // Call the API directly since the thunk doesn't return the response
    dispatch({ type: "UNDO_CANCEL_SUBSCRIPTION_REQUEST" });

    undoCancelSubcription(activeSubscription._id)
      .then((response) => {
        if (response && response.success) {
          // Force update the Redux state with the updated subscription
          const updatedSubscription = {
            ...activeSubscription,
            hasCancelRequest: false,
          };

          // Update Redux state
          dispatch({
            type: "FETCH_ACTIVE_SUBSCRIPTION_PLAN_SUCCESS",
            payload: { activeSubscription: updatedSubscription },
          });

          // Also update for success action
          dispatch({
            type: "UNDO_CANCEL_SUBSCRIPTION_SUCCESS",
            payload: { undoCancellation: response?.data },
          });

          console.log("undo cancel response", response);

          enqueueSnackbar(
            "Your subscription is active again! Cancellation undone.",
            { variant: "success" }
          );
        }
      })
      .catch((error) => {
        dispatch({
          type: "UNDO_CANCEL_SUBSCRIPTION_FAILURE",
          payload: error.message,
        });

        enqueueSnackbar(
          "Error while processing undo cancellation request. Please try again.",
          { variant: "error" }
        );
      })
      .finally(() => setIsCancelLoading(false));
  };
  return (
    <div className=" border rounded-lg p-4 bg-white gap-7 text-primary w-full overflow-auto">
      {isLoading ? (
        <div className="gap-2.5 flex mt-16 flex-col">
          {Array.from({ length: 10 }, (x, i) => i).map((key) => {
            return (
              <div key={key} className="flex justify-between">
                <div
                  style={{
                    borderWidth: 1,
                  }}
                  className="flex rounded-lg w-full pl-3 pr-8 py-4 gap-1.5"
                >
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className=" flex flex-col gap-7 pb-8">
          <div className="px-5 pt-8">
            <h1 className="text-2xl font-bold">My Subscription</h1>
          </div>
          <div className="px-5">
            <div className="border rounded-lg bg-[#f9fafb] p-5">
              <div className="flex justify-between  items-center w-full">
                {activeSubscription == undefined ? (
                  <h1 className="text-xl font-bold">Free Plan</h1>
                ) : (
                  <h1 className="text-xl font-black">Pro Monthly Plan</h1>
                )}
                <div className="flex gap-4">
                  <button className="rounded-full px-4 py-1 bg-[#d1f7c4] text-[#2e7d32] font-bold text-sm">
                    Active
                  </button>
                  {activeSubscription !== undefined &&
                    activeSubscription?.hasCancelRequest && (
                      <button className=" rounded-full px-4 py-1 bg-gray-300 font-bold text-sm text-gray-500">
                        Cancels{" "}
                        {dayjs(activeSubscription?.endDate).format("MMMM D")}
                      </button>
                    )}
                </div>
              </div>
              <div className="text-sm/6 font-medium">
                <p>
                  {" "}
                  Started on:{" "}
                  {activeSubscription == undefined
                    ? "NA"
                    : dayjs(activeSubscription?.startDate).format(
                        "MMMM D, YYYY"
                      )}{" "}
                </p>
                <p>
                  Next renewal:{" "}
                  {activeSubscription === undefined
                    ? "NA"
                    : dayjs(activeSubscription?.endDate).format(
                        "MMMM D, YYYY"
                      )}{" "}
                </p>
                <p>
                  Price:{" "}
                  {activeSubscription === undefined
                    ? "Free"
                    : `£${activeSubscription?.planDetails?.amount} / ${
                        activeSubscription?.planDetails?.recurringType ==
                        "month"
                          ? "month"
                          : "year"
                      }`}{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="px-5">
            <h1 className="text-xl font-bold pb-2 border-b border-[#f0f0f0]">
              Plan Benefits
            </h1>
            {activeSubscription == undefined ? (
              <h1>NA</h1>
            ) : (
              <ul className="text-sm font-medium  border-b-[#f0f0f0] pt-4">
                <li className="py-1.5 border-b border-[#f0f0f0]">
                  50 active job postings per month
                </li>
                <li className="py-1.5 border-b border-[#f0f0f0]">
                  Unlimited candidate profile views
                </li>
                <li className="py-1.5 border-b border-[#f0f0f0]">
                  10 featured job credits per month
                </li>
                <li className="py-1.5 border-b border-[#f0f0f0]">
                  Access to permium candidate pool
                </li>
                <li className="py-1.5 border-b border-[#f0f0f0]">
                  Dedicated account manager
                </li>
              </ul>
            )}
          </div>
          <div className="px-5">
            <h1 className="text-xl font-bold pb-2 border-b border-[#f0f0f0]">
              Billing Information
            </h1>
            <div className="text-sm/8 font-medium  border-b-[#f0f0f0] pt-4">
              <p>
                Payment method:{" "}
                {activeSubscription === undefined
                  ? "NA"
                  : `**** **** **** ${
                      activeSubscription?.paymentMethodDetails?.last4
                    } (${activeSubscription?.paymentMethodDetails?.brand.toUpperCase()})`}{" "}
              </p>
              <p>
                Latest invoice:
                {activeSubscription === undefined ? (
                  <span> NA </span>
                ) : (
                  // <button
                  //   className="rounded-lg px-4 py-2 text-white font-bold text-sm bg-blue-500 hover:bg-blue-700 ml-2"
                  //   onClick={() =>
                  //     window.open(activeSubscription?.invoicePdf, "_blank")
                  //   }
                  // >
                  //   Download PDF
                  // </button>
                  <Link
                    to={`/transactions/details/${activeSubscription.paymentHistoryId}/subscription`}
                    className="text-blue-600 font-semibold"
                  >
                    {" "}
                    View latest invoice
                  </Link>
                )}
              </p>
              <p>
                Billing history:{" "}
                <span className="cursor-pointer">
                  {/* <a onClick={() => navigate("/transactions")}>
                    View all invoices
                  </a> */}
                  <Link
                    to="/transactions"
                    className="text-blue-600 font-semibold"
                    state={{ type: "subscription" }}
                  >
                    View all invoices
                  </Link>
                </span>
              </p>
            </div>
          </div>
          <div className="px-5 flex gap-5 text-white font-semibold items-center">
            <button
              className="bg-secondary hover:bg-orange-600  px-4 py-2 rounded-lg "
              onClick={handleUpgradePlan}
            >
              Upgrade Plan
            </button>
            {activeSubscription && activeSubscription?.hasCancelRequest ? (
              <button
                className={`bg-green-500 px-4 py-2 rounded-lg flex items-center justify-center gap-2 ${
                  isCancelLoading
                    ? "opacity-70 cursor-not-allowed"
                    : "hover:bg-green-600 cursor-pointer"
                }`}
                onClick={handleUndoCancelSubscription}
                disabled={isCancelLoading}
              >
                <span>Undo Cancel</span>
                {isCancelLoading && <LoadingAnimation />}
              </button>
            ) : (
              activeSubscription !== undefined && (
                <button
                  className={`bg-red-500 px-4 py-2 rounded-lg flex items-center justify-center gap-2 ${
                    isCancelLoading
                      ? "opacity-70 cursor-not-allowed"
                      : "hover:bg-red-700 cursor-pointer"
                  }`}
                  onClick={handleCancelSubscription}
                  disabled={isCancelLoading}
                >
                  <span>Cancel Subscription</span>
                  {isCancelLoading && <LoadingAnimation />}
                </button>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MySubscriptionPage;
